import { UseStepperState, UseStepperDispatch } from 'state/hooks/use-stepper';
import { UseFormState, UseFormDispatch, MaybeErrorMap } from 'state/hooks/use-form-map';
import { DragIndices } from 'state/hooks/ui/use-dragdrop';

type Activity = any; // TODO

export enum AssignmentEngineParams {
  EDIT = 'edit',
  BLANK = 'blank',
  SINGLE = 'single'
}

// this should match the property names coming from the back-end
export enum AssignmentKey {
  LESSON = 'lesson',
  ASSIGNED = 'assigned',
  AUDIO_FILES = 'audioFiles',
  DAY_OF_WEEK = 'dayOfWeek',
  DUE_DATE = 'dueDate',
  ID = 'id',
  INSTRUCTIONS = 'instructions',
  START_DATE = 'startDate'
}

export type StepOneForm = {
  title: string;
  subtitle: string;
  startDate: string;
  dueDate: string;
  instructions: string;
  audioFiles: File[];
  lesson: { sections: any[]; classroomId: number; studentIds: number[] };
  assigned: boolean;
  id: string;
};

export type StepOneFormMap = {
  [key: string]: StepOneForm;
};

export type StepTwoForm = {
  classroomIds: number[];
  studentIds: number[];
};

export type TeacherInstructionPayload = {
  assignmentId: number;
  audioFiles: any[];
};

export type AssignmentPayload = {
  teachingOrderLessonId: number;
  title: string;
  maxAttempts: number;
  dateAssigned: string;
  dateDue: string;
  classroomId: string;
  studentIds: string[];
  instructions: string;
  sections: any;
};
export enum ActiveFormVariant {
  READ_ONLY = 'read-only',
  EDITABLE = 'editable'
}

export type LessonAssignmentState = {
  activeFormId: string;
  activeFormVariant: ActiveFormVariant;
  isEditingTitle: boolean;
  lastActiveFormId: string;
  studentsAndClassrooms: any[];
  classrooms?: any[];
  students?: any[];
  dateRange: string;
};
export interface LessonAssignmentDispatch {
  setActiveForm: (key: string) => MaybeErrorMap;
  toggleEditTitle: () => void;
  getAssignmentPayload: () => Array<AssignmentPayload>;
  getTeacherInstructionPayload: (
    assignments: any[],
    updating?: boolean
  ) => Array<TeacherInstructionPayload>;
  onRemoveAssignment: (id: string) => void;
  setSelectedClassroomsAndStudents: (studentsAndClassrooms: any) => Promise<any>;
  setClassrooms: (classrooms: any[]) => any;
}

type UseLessonAssignmentState = {
  stepperState: UseStepperState;
  stepOneFormState: UseFormState<StepOneFormMap>;
  stepTwoFormState: UseFormState<StepTwoForm>;
  lessonAssignmentState: LessonAssignmentState;
};

type UseLessonAssignmentDispatch = {
  stepperDispatch: Omit<UseStepperDispatch, 'completeActiveStepAndSetNextStep'> & {
    completeActiveStepAndSetNextStep: (stepNumber: number) => Promise<MaybeErrorMap>;
  };
  stepOneFormDispatch: Omit<UseFormDispatch<StepOneFormMap>, 'onFormChange'> & {
    onFormChange: (name: string, value: any) => void;
    onMoveActivity: (originIndices: DragIndices, targetIndices: DragIndices) => void;
    onAddActivity: (activitySection: any, activity: Activity) => void;
    onRemoveActivity: (sectionIdx: number, activityId: number, activitySection: string) => void;
    onUnassignActiveForm: (id: string) => void;
    handleAssign: (id: string) => void;
    onRemoveAllActivities: (sectionIdx: number | undefined, activitySection: string) => void;
    onRemoveFileAdded: (name: string) => void;
    handleDateChange: (name: any, value: any) => void;
  };
  stepTwoFormDispatch: UseFormDispatch<StepTwoForm> & {
    onMultiSelectFormChange: (name: string, value: any) => void;
    setPreselectedClassroomsAndStudents: (classroomIds: number[], studentIds: number[]) => void;
  };
  lessonAssignmentDispatch: LessonAssignmentDispatch;
};

export type UseLessonAssignment = [UseLessonAssignmentState, UseLessonAssignmentDispatch];
